<template>
  <el-dialog
    title="修改服务记录"
    :visible.sync="dialogVisible"
    width="520px"
    custom-class="service-record-edit-dialog"
    center
    destroy-on-close
    :close-on-click-modal="false"
    @closed="resetForm"
  >
    <div class="service-record-edit-body">
      <el-form ref="editRecordForm" :model="editRecordForm" label-width="88px" label-position="left">
        <el-form-item label="考勤情况">
          <el-radio-group v-model="editRecordForm.attendance">
            <el-radio label="1">正常</el-radio>
            <el-radio label="2">请假</el-radio>
            <el-radio label="3">放假</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="服务时间">
          <el-date-picker
            v-model="editRecordForm.serviceTime"
            type="date"
            placeholder="请选择服务时间"
            value-format="timestamp"
            format="yyyy-MM-dd"
            class="w100"
          />
        </el-form-item>
        <template v-if="editRecordForm.attendance === '1'">
          <el-form-item label="服务内容" class="service-content-form-item">
            <el-checkbox-group
              v-model="editRecordForm.selectedServiceIds"
              class="service-checkbox-group"
            >
              <el-checkbox-button
                v-for="s in editRecordCatalog"
                :key="'cat-' + String(s.id)"
                :label="String(s.id)"
              >{{ s.name }}</el-checkbox-button>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="服务图片" label-position="top">
            <el-upload
              action="#"
              :http-request="uploadFile"
              list-type="picture-card"
              :limit="9"
              :file-list="fileList"
              :on-remove="handleRemove"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </template>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer edit-record-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import pictureCompress from 'picture-compressor'
import { editBoardingServiceRecord, fetchCriArticleServices, uploadImgs } from '@/api'

export default {
  name: 'BoardingEditServiceRecord',
  props: {
    orderId: { type: [String, Number], default: '' },
    dir: { type: String, default: '' }
  },
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      editRecordForm: { record_id: '', serviceTime: null, attendance: '1', selectedServiceIds: [] },
      editRecordSnapshot: null,
      editRecordCatalog: [],
      fileList: []
    }
  },
  methods: {
    tsToMs(ts) {
      if (ts == null || ts === '') return null
      const n = Number(ts)
      return n < 1e12 ? n * 1000 : n
    },
    parseJsonArrayField(val) {
      if (val == null) return null
      if (Array.isArray(val)) return val
      if (typeof val === 'string') {
        const t = val.trim()
        if (!t) return null
        try { const p = JSON.parse(t); return Array.isArray(p) ? p : null } catch (e) { return null }
      }
      return null
    },
    pickServiceItemId(it) {
      if (!it || typeof it !== 'object') return ''
      const v = it.id != null && it.id !== '' ? it.id : it.item_id != null && it.item_id !== '' ? it.item_id : it.service_id != null && it.service_id !== '' ? it.service_id : ''
      return v === '' || v === undefined ? '' : String(v)
    },
    serviceRecordItems(row) {
      if (!row) return []
      const si = row.service_item
      if (Array.isArray(si) && si.length) {
        return si.map(s => {
          if (s && typeof s === 'object') {
            return { id: this.pickServiceItemId(s), name: s.name || '', price: s.price != null ? s.price : '' }
          }
          return { id: String(s), name: '', price: '' }
        }).filter(s => s.id || s.name)
      }
      const raw = this.parseJsonArrayField(row.service_json) || this.parseJsonArrayField(row.services_json)
      if (!raw || !raw.length) {
        if (si != null && String(si).trim() !== '') {
          return String(si).split(',').map(x => x.trim()).filter(Boolean).map(id => ({ id, name: '', price: '' }))
        }
        return []
      }
      return raw.filter(s => s && (s.name || s.price != null || this.pickServiceItemId(s)))
    },
    legacyServiceLines(row) {
      if (!row.services || !row.services.length) return []
      return row.services
    },
    normalizeNurseServiceItem(raw) {
      if (!raw || typeof raw !== 'object') return null
      const id = raw.id != null ? raw.id : raw.item_id != null ? raw.item_id : raw.service_id
      if (id === '' || id === undefined || id === null) return null
      return { id: String(id), name: raw.name != null ? raw.name : '', price: raw.price != null ? raw.price : '' }
    },
    async loadCatalog() {
      const params = {}
      if (this.orderId) { const oid = Number(this.orderId); params.order_id = Number.isFinite(oid) ? oid : this.orderId }
      const { status, data } = await fetchCriArticleServices(params)
      if (status && data != null) {
        const rawList = Array.isArray(data) ? data : data.list || []
        this.editRecordCatalog = rawList.map(r => this.normalizeNurseServiceItem(r)).filter(Boolean)
      } else { this.editRecordCatalog = [] }
    },
    buildSelectedIdsFromRow(row) {
      const items = this.serviceRecordItems(row)
      const list = items.length ? items : this.legacyServiceLines(row)
      const ids = []
      list.forEach(it => {
        let sid = this.pickServiceItemId(it)
        if (!sid && it.name) {
          const m = this.editRecordCatalog.find(c => c.name === it.name && String(c.price) === String(it.price))
          if (m) sid = String(m.id)
        }
        if (sid && this.editRecordCatalog.some(c => String(c.id) === sid) && !ids.includes(sid)) {
          ids.push(sid)
        }
      })
      return ids.slice(0, 5)
    },
    rowImgList(row) {
      if (!row || !row.img_urls) return []
      if (Array.isArray(row.img_urls)) return row.img_urls.filter(Boolean)
      const s = String(row.img_urls).trim()
      if (!s) return []
      return s.split(',').map(x => x.trim()).filter(Boolean)
    },
    async open(row) {
      if (!row || row.id == null) { this.$message.warning('记录数据异常'); return }
      await this.loadCatalog()
      this.editRecordSnapshot = row
      const startKey = row.service_at != null && row.service_at !== '' ? 'service_at' : 'dis_start_at'
      const startMs = this.tsToMs(row[startKey])
      const attendance = row.attendance != null && row.attendance !== '' ? String(row.attendance) : '1'
      this.editRecordForm = {
        record_id: row.id,
        serviceTime: startMs != null ? startMs : null,
        attendance,
        selectedServiceIds: attendance === '1' ? this.buildSelectedIdsFromRow(row) : []
      }
      this.fileList = attendance === '1' ? this.rowImgList(row).map(u => ({ url: u })) : []
      this.dialogVisible = true
    },
    resetForm() {
      this.editRecordSnapshot = null
      this.editRecordForm = { record_id: '', serviceTime: null, attendance: '1', selectedServiceIds: [] }
      this.editRecordCatalog = []
      this.fileList = []
    },
    handleRemove(file) {
      this.fileList = this.fileList.filter(f => f.uid !== file.uid)
    },
    uploadFile(item) {
      const _this = this
      const reader = new FileReader()
      reader.readAsDataURL(item.file)
      reader.onload = function() {
        pictureCompress({
          img: reader.result,
          width: 500,
          height: 500
        }).then(res => {
          const params = {
            data: res.img,
            fileName: item.file.uid
          }
          uploadImgs(params)
            .then(resp => {
              if (resp.status) {
                _this.fileList.push({ uid: item.file.uid, ...resp.data })
              }
            })
            .catch(() => {})
        })
      }
    },
    submit() {
      const { record_id, serviceTime, attendance, selectedServiceIds } = this.editRecordForm
      if (!record_id) { this.$message.warning('缺少记录 ID'); return }
      if (!serviceTime) { this.$message.warning('请选择服务时间'); return }
      const oid = Number(this.orderId)
      const params = {
        id: record_id,
        order_id: Number.isFinite(oid) ? oid : this.orderId,
        service_time: Math.floor(Number(serviceTime) / 1000),
        attendance
      }
      if (attendance === '1') {
        const ids = (selectedServiceIds || []).filter(Boolean)
        if (!ids.length) { this.$message.warning('请至少选择一项服务内容'); return }
        params.service_item = ids.join(',')
        params.img_urls = this.fileList.map(f => f.url).filter(Boolean).join(',')
      }
      this.submitLoading = true
      editBoardingServiceRecord(params)
        .then(res => {
          if (res.status) {
            this.$message.success(res.msg || '保存成功')
            this.dialogVisible = false
            this.$emit('success')
          } else {
            this.$message.warning(res.msg || '保存失败')
          }
        })
        .finally(() => { this.submitLoading = false })
    }
  }
}
</script>

<style lang="scss" scoped>
.w100 { width: 100%; }
.service-checkbox-group { display: flex; flex-wrap: wrap; }
.service-checkbox-group ::v-deep .el-checkbox-button { margin: 0 8px 8px 0; }
.service-checkbox-group ::v-deep .el-checkbox-button__inner { border-radius: 4px; border-left: 1px solid #dcdfe6; }
</style>
